
export const currentEnv = import.meta.env.VITE_APP_ENV;

export enum Env {
  production = 'production',
  staging = 'staging'
}

export enum Service {
  zcp = 'zcp',
  zcd = 'zcd',
  aii = 'aii'
}

export const services = [Service.zcp, Service.zcd, Service.aii] as const

export enum Role {
  zcp = 'zcp-rc-user',
  zcd = 'z-career-user',
  aii = 'ai-interview-user'
}

export const roles = [Role.zcp, Role.zcd, Role.aii] as const

export const serviceUrl = {
  [Service.zcp]: {
    [Env.production]: 'https://company.agent-bank.com',
    [Env.staging]: 'https://company.stg-agent-bank.com'
  },
  [Service.zcd]: {
    [Env.production]: 'https://company.direct.zcareer.com',
    [Env.staging]: 'https://company.direct.stg2.zcareer.com'
  },
  [Service.aii]: {
    [Env.production]: 'https://company.ai-interview.zcareer.com',
    [Env.staging]: 'https://company.ai-interview.stg.zcareer.com'
  },
} as const

export const getServiceURL = (service: Service): string => {
  if (currentEnv === Env.production) {
    return serviceUrl[service][Env.production]
  }
  return serviceUrl[service][Env.staging]
}

/**
 * company-auth の公開エンドポイントの基底 URL（パスワード再設定の申請で呼ぶ）。
 *
 * **公開経路（API Gateway）はサービスごとの名前空間をパスの先頭に持つ**ため、基底 URL には
 * その接頭辞（`/general`）まで含める。呼び出し側はサービス自身のパス
 * （`/user/password-reset/request`）を後ろに繋ぐ。
 *
 * **テナントによらない値**なので、テナントごとの配信設定（Pages プロジェクト）ではなく
 * ここに持つ（提携先が増えても設定箇所が増えない）。公開経路が自動発行するホスト名を
 * 用いており、経路を作り直すと変わるため、`VITE_COMPANY_AUTH_API_ORIGIN` で上書きできる
 * ようにしてある（コード変更なしで直せる余地を残す）。
 *
 * 値が空の環境では要求せず失敗として扱う（設定不備を受付として隠さない）。
 */
export const companyAuthApiBaseUrl = {
  [Env.production]: 'https://company-auth-gateway-ou18njf.an.gateway.dev/general',
  [Env.staging]: 'https://company-auth-gateway-bqrybooc.an.gateway.dev/general',
} as const

export const getCompanyAuthApiBaseUrl = (): string => {
  const override = (import.meta.env.VITE_COMPANY_AUTH_API_ORIGIN ?? '').trim()
  if (override) {
    return override
  }
  if (currentEnv === Env.production) {
    return companyAuthApiBaseUrl[Env.production]
  }
  return companyAuthApiBaseUrl[Env.staging]
}

export const roleToService = (role: string): Service | null => {
  if (role === Role.zcp) {
    return Service.zcp
  }
  if (role === Role.zcd) {
    return Service.zcd
  }

  if (role === Role.aii) {
    return Service.aii
  }
  return null
}

export const serviceToRole = (service: string): Role | null => {
  if (service === Service.zcp) {
    return Role.zcp
  }
  if (service === Service.zcd) {
    return Role.zcd
  }

  if (service === Service.aii) {
    return Role.aii
  }
  return null
}
